import { Row, Col } from '../../../utils/grid/Grid';
import Bar from './Bar';
import { formatNumber } from '../../../utils/Formatter';

interface RatingWithBarProps {
  label: string;
  rating: number;
}

export default function RatingWithBar({ label, rating }: RatingWithBarProps): JSX.Element {
  return (
    <Row>
      <Col xs={5}>{label}</Col>
      <Col xs={5}>
        <Bar rating={rating} />
      </Col>
      <Col xs={2}>{formatNumber(rating, { precision: 1 })}</Col>
    </Row>
  );
}
